
export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType = typeof MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType[keyof typeof MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
